







































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Location from '@/models/Location';

const AuthStore = namespace('auth');
const ApplicationStore = namespace('application');

@Component({})
export default class LocationStatusComponent extends Vue {

    @AuthStore.Getter('currentLocation')
    private _location!: Location | null;

    @AuthStore.Getter('localizationTimeOut')
    private _localizationTimeOut!: boolean;

    @ApplicationStore.Getter('termsAndConditionsConfirmed')
    private termsAndConditionsConfirmed!: boolean | null;

    @ApplicationStore.Mutation('setTermsAndConditionsDialog')
    private setTermsAndConditionsDialog!: (value: boolean) => void;

    get localizationTimeOut(): boolean {
        return this._localizationTimeOut;
    }

    @AuthStore.Mutation('setLocalizationTimeOut')
    private setLocalizationTimeOut!: (value: boolean) => void;

    get location() {
        return this._location;
    }

    public resetLocalization() {
        if (this.termsAndConditionsConfirmed) {
            this.setLocalizationTimeOut(false);
        } else {
            this.setTermsAndConditionsDialog(true);
        }
    }
};
